module.exports = __webpack_public_path__ + "media/piano.f522542f.mp3";